module.exports = "<!-- ============================================================== -->\n<!-- Only router without any element -->\n<!-- ============================================================== -->\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /Users/igor/Projects/onechat/admin-dashboard/src/app/layouts/blank/blank.component.html
// module id = ../../../../../src/app/layouts/blank/blank.component.html
// module chunks = main